import { createFileRoute } from '@tanstack/react-router';

import { JadePageContent } from '~/components/products/jade/JadePageContent';

const JadePage = () => {
  return <JadePageContent />;
};

export const Route = createFileRoute('/$locale/products/iris')({
  component: JadePage,
});
